import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import Dialogtype, { Dialog } from 'src/app/libs/dialog.lib';
import { LoaderService } from '../services/shared/loader.service';

@Injectable({
    providedIn: 'root'
})

export class HttpConfigInterceptor implements HttpInterceptor {

    isRefreshing = false;
    requestCount = 0;
    refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
        public loaderService: LoaderService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const shouldShowLoader = !request.url.includes('noload') && !request.headers.get('skip');

        if (shouldShowLoader) {
            this.requestCount++;
            this.loaderService.show();
        }

        if (request.headers.get('skip'))
            return next.handle(request);

        if (!request.url.includes('nocontent')) {
            if (!request.headers.has('Content-Type'))
                request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        if (!request.headers.has('Accept'))
            request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        return next.handle(request).pipe(
            finalize(() => {
                if (shouldShowLoader) {
                    this.requestCount--;
                    if (this.requestCount === 0) {
                        this.loaderService.hide();
                    }
                }
            }),
            catchError((error: HttpErrorResponse) => {
                let data: any = {};
                data = {
                    reason: error && error.error && error.error.message ? error.error.message : '',
                    status: error.status,
                    message: error && error.error && error.error.error ? error.error.error_description : error.message,
                    exceptionMessage: error && error.error ? error.error.exceptionMessage : error.message,
                    exceptionType: error && error.error ? error.error.exceptionType : null,
                };

                if (data["status"] != "" && data["status"] == "500") {
                    Dialog.show('Ha ocurrido un error en el servidor', Dialogtype.error).subscribe();
                    return throwError(() => new Error(`error-->>> ${JSON.stringify(data)}`));
                }
                else if (data["status"] != "" && data["status"] == "400") {
                    if (data["reason"] != undefined) {
                        Dialog.show('Bad request, Verifique los datos enviados', Dialogtype.error).subscribe();
                    }
                    return throwError(() => new Error(`error-->>> ${JSON.stringify(data)}`));
                }
                else if (data["status"] != "" && data["status"] == "401") {
                    Dialog.show('No estás autorizado para realizar esta operación', Dialogtype.warning);
                    return throwError(() => new Error(`error-->>> ${JSON.stringify(data)}`));
                }
                else {
                    if (data["message"] != undefined) {
                        Dialog.show(data["message"], Dialogtype.error).subscribe();
                    }
                    return throwError(() => new Error(`error-->>> ${JSON.stringify(data)}`));
                }
            })
        );
    }

}

